import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-4 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-book-2-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">御书屋</span>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-background-300">
              御书屋致力于为网络小说爱好者提供清爽整洁的阅读体验，涵盖玄幻、言情、历史等热门分类，
              支持目录浏览、分类筛选、关键词搜索与多章节在线阅读。
            </p>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-base font-semibold text-background-50">
              热门分类
            </h3>
            <ul className="space-y-2 text-sm">
              {categories.slice(0, 6).map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-background-300 transition-colors hover:text-accent-400"
                  >
                    {category.name}小说
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-base font-semibold text-background-50">
              站内导航
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/xuanhuan"
                  className="text-background-300 transition-colors hover:text-accent-400"
                >
                  分类书架
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-background-300 transition-colors hover:text-accent-400"
                >
                  搜索小说
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-300 transition-colors hover:text-accent-400"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 御书屋 版权所有 · 本站为阅读体验演示站点，不含注册、支付与下载功能。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            内容仅供参考，提倡正版阅读
          </p>
        </div>
      </div>
    </footer>
  );
}